import { useEffect } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Link, Navigate, useParams } from 'react-router-dom';
import logo from '../../images/common/kofc.png';
import CharitiesList from './CharitiesList';
import PrincipleIcon from './PrincipleIcon';
import { getPrinciple, PRINCIPLES } from './principlesData';

export default function PrincipleDetailPage() {
  const { principleId } = useParams<{ principleId: string }>();
  const principle = getPrinciple(principleId);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [principleId]);

  if (!principle) {
    return <Navigate to="/" replace />;
  }

  const others = PRINCIPLES.filter((p) => p.id !== principle.id);

  return (
    <div className="principles-page principle-detail-page">
      <section className="principles-hero">
        <Container>
          <div className="principles-hero-inner">
            <img src={logo} alt="" className="principles-crest" />
            <div>
              <p className="eyebrow mb-1">
                <a href="/#principles" className="principles-hero-back">
                  Our Principles
                </a>
                {' / '}
                {principle.title}
              </p>
              <h1>{principle.title}</h1>
              <p className="principles-subhead mb-0">{principle.tagline}</p>
            </div>
          </div>
        </Container>
      </section>

      <section className="section">
        <Container>
          <Card className="soft-card mb-3">
            <Card.Body>
              <Row className="g-3 align-items-start">
                <Col xs="auto">
                  <div className="principle-icon-wrap principle-icon-wrap-lg">
                    <PrincipleIcon kind={principle.id} />
                  </div>
                </Col>
                <Col>
                  <blockquote className="principle-quote mb-2">{principle.quote}</blockquote>
                  <p className="principle-quote-source mb-0">{principle.quoteSource}</p>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          <Card className="soft-card mb-3">
            <Card.Body>
              {principle.body.map((para, i) => (
                <p key={i} className={i === principle.body.length - 1 ? 'mb-0' : undefined}>
                  {para}
                </p>
              ))}
            </Card.Body>
          </Card>

          <h2 className="h4 mb-3">In practice</h2>
          <Row className="g-3 mb-4">
            {principle.highlights.map((h) => (
              <Col md={4} key={h.title}>
                <Card className="soft-card h-100">
                  <Card.Body>
                    <h3 className="h6 principle-title">{h.title}</h3>
                    <p className="mb-0 text-muted">{h.text}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>

          {principle.id === 'charity' && <CharitiesList embedded />}

          <h2 className="h5 mb-3">Explore the other principles</h2>
          <div className="principles-jump">
            {others.map((p) => (
              <Link key={p.id} to={`/principles/${p.id}`} className="principles-jump-link">
                {p.title}
              </Link>
            ))}
          </div>
        </Container>
      </section>

      <section className="support-band principles-cta">
        <Container>
          <Row className="align-items-center g-3">
            <Col md={7}>
              <h2 className="h3 mb-2">Live {principle.title.toLowerCase()} with Council 1056</h2>
              <p className="mb-0">
                Catholic men 18 and older are welcome to join us at St. Mary Parish in Delaware,
                Ohio.
              </p>
            </Col>
            <Col md={5} className="d-flex flex-wrap gap-2 justify-content-md-end">
              <Button
                href="https://www.kofc.org/join/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-gold"
              >
                Become a Knight
              </Button>
              <Button as={Link as any} to="/events" className="btn-gold-outline-light">
                See upcoming events
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}